export const renderFlags = {
  domDirty: false,
  layoutDirty: false,
  linesDirty: false
};
